import React from 'react';
import { selectAlertMessage, setAlertMessage } from 'features/dashboard/dashboardSlice';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { Alert } from 'components/alert';
import { useRouter } from 'next/router';

export const InactiveMessage = () => {
  const { isReady } = useRouter();
  const dispatch = useAppDispatch();
  const alertMessage = useTypedSelector(selectAlertMessage);

  if (isReady && alertMessage) {
    // avoid idration error
    return (
      <Alert
        btn={alertMessage.btn}
        icon={alertMessage.icon}
        color={alertMessage.color}
        message={alertMessage.message}
        animation={alertMessage.animation}
        actionAfterTimeout={() => dispatch(setAlertMessage(undefined))}
      />
    );
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment />;
};
